import { render } from "./DeviceRecordsTable.vue?vue&type=template&id=6fd356e5&ts=true"
import script from "./DeviceRecordsTable.vue?vue&type=script&lang=ts"
export * from "./DeviceRecordsTable.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__